import React, { useEffect, useState } from "react";

import { getCommonConfig, updateCommonConfig } from "@/services/commonconfig";

const AppUrlConfig: React.FC = () => {
  const [fluxxUrl, setFluxxUrl] = useState("");
  const [powerBiUrl, setPowerBiUrl] = useState("");
  const [initial, setInitial] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await getCommonConfig();

    setFluxxUrl(res.FluxxURL || "");
    setPowerBiUrl(res.PowerBIURL || "");

    setInitial(JSON.stringify(res));
  };

  const hasChanges =
    initial !== "" &&
    (fluxxUrl !== JSON.parse(initial).FluxxURL || powerBiUrl !== JSON.parse(initial).PowerBIURL);

  const handleSave = async () => {
    setSaving(true);

    const parsed = JSON.parse(initial);

    await updateCommonConfig({
      LogoutTime: parsed.LogoutTime,
      WarningTime: parsed.WarningTime,
      InactiveDays: parsed.InactiveDays,
      TourIcon: parsed.TourIcon,
      NotificationIcon: parsed.NotificationIcon,
      LanguageSwitchIcon: parsed.LanguageSwitchIcon,
      FluxxURL: fluxxUrl,
      PowerBIURL: powerBiUrl,
    });

    setInitial(
      JSON.stringify({
        ...parsed,
        FluxxURL: fluxxUrl,
        PowerBIURL: powerBiUrl,
      })
    );

    setSaving(false);
  };

  const handleCancel = () => {
    const parsed = JSON.parse(initial);

    setFluxxUrl(parsed.FluxxURL || "");
    setPowerBiUrl(parsed.PowerBIURL || "");
  };

  return (
    <div className="border border-gray-200 rounded-md bg-[#fbfaf7] p-3 space-y-4">
      <div className="flex items-center gap-4 text-xs">
        <span className="w-40 text-gray-700">Fluxx URL</span>

        <input
          type="text"
          value={fluxxUrl}
          onChange={(e) => setFluxxUrl(e.target.value)}
          className="flex-1 border border-gray-300 rounded px-3 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-[var(--color-brand)]"
          placeholder="Enter Fluxx URL"
        />
      </div>

      <div className="flex items-center gap-4 text-xs">
        <span className="w-40 text-gray-700">Power BI URL</span>

        <input
          type="text"
          value={powerBiUrl}
          onChange={(e) => setPowerBiUrl(e.target.value)}
          className="flex-1 border border-gray-300 rounded px-3 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-[var(--color-brand)]"
          placeholder="Enter Power BI URL"
        />
      </div>

      <div className="flex justify-end gap-2 items-center">
        {hasChanges && (
          <div className="text-orange-600 border border-orange-300 bg-orange-50 px-2 py-0.5 rounded text-xs">
            Unsaved
          </div>
        )}

        <button
          className="bg-[#e7e5e0] px-3 py-1 rounded text-xs"
          onClick={handleCancel}
          disabled={!hasChanges}
        >
          Cancel
        </button>

        <button
          className="bg-[var(--color-brand)] text-white px-3 py-1 rounded text-xs"
          onClick={handleSave}
          disabled={!hasChanges || saving}
        >
          {saving ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default AppUrlConfig;
